import React from 'react';
// might need to change the names to something nicer.
const variants = {
    'heading1.1': 'font-PoppinsMedium text-22/32',
    'heading1.2': 'font-PoppinsSemi text-22/32',
    'heading2.1': 'font-PoppinsSemi text-16/24',
    'heading2.2': 'font-PoppinsMedium text-16/24',
    'heading2.3': 'font-PoppinsRegular text-16/24',
    'heading3.1': 'font-PoppinsSemi text-14/20',
    'heading3.2': 'font-PoppinsMedium text-14/20',
    'heading4': 'font-PoppinsRegular text-12/18',
    'body1': 'font-InterMedium text-16/24',
    'body1.2': 'font-InterRegular text-16/20',
    'body2': 'font-InterRegular text-14/18',
    'body3': 'font-InterRegular text-12/18'
}

export const Typography = ({ variant, color, className, children }) => {

    return (
        <div className={`${variants[variant]} text-${color} ${className}`}>
            {children}
        </div>
    )
}